import { createAction, props } from '@ngrx/store';

export type ThemeName = 'azdhs' | 'azdhs-dark';

enum ThemeUIActionTypes {
  SetTheme = '[Theme] Set Theme',
  ToggleTheme = '[Theme] Toggle Theme',
  SetSystemPreference = '[Theme] Set System Preference',
}

export const SetTheme = createAction(ThemeUIActionTypes.SetTheme, props<{ theme: ThemeName }>());

export const ToggleTheme = createAction(ThemeUIActionTypes.ToggleTheme);

export const SetSystemPreference = createAction(
  ThemeUIActionTypes.SetSystemPreference,
  props<{ prefersDark: boolean }>()
);
